var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-0 text-danger font-italic"},[_vm._v("Automatyczne zatwierdzenie za: "+_vm._s(_vm.timer))]),_c('div',{staticClass:"mb-3 text-danger font-italic"},[_vm._v("Zamknij skrzynkę do tego czasu")])])}
var staticRenderFns = []

export { render, staticRenderFns }